webpackJsonp([91091470223668],{

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _glamorous = __webpack_require__(13);
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	var _reactHelmet = __webpack_require__(38);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _banner = __webpack_require__(26);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _responsiveMargin = __webpack_require__(27);
	
	var _responsiveMargin2 = _interopRequireDefault(_responsiveMargin);
	
	var _sitenav = __webpack_require__(28);
	
	var _sitenav2 = _interopRequireDefault(_sitenav);
	
	var _CharacterBio2PageHero402x = __webpack_require__(98);
	
	var _CharacterBio2PageHero402x2 = _interopRequireDefault(_CharacterBio2PageHero402x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return Glamor.createElement(
	    'div',
	    null,
	    Glamor.createElement(_reactHelmet2.default, { title: 'Alfred Stieglitz | The Realist | Sarah Coleman' }),
	    Glamor.createElement(_banner2.default, { imageUrl: _CharacterBio2PageHero402x2.default }),
	    Glamor.createElement(_sitenav2.default, null),
	    Glamor.createElement(
	      _responsiveMargin2.default,
	      { css: { maxWidth: '640px' } },
	      Glamor.createElement(
	        'h6',
	        null,
	        'The Realist | Character Bios'
	      ),
	      Glamor.createElement(
	        'h2',
	        null,
	        'Alfred Stieglitz'
	      ),
	      Glamor.createElement(
	        'p',
	        null,
	        'Artistic trailblazer and aesthetic gadfly; cultural tastemaker and creative naysayer; artistic rebel and aesthetic authoritarian. Over the course of his 82-year life, Alfred Stieglitz played myriad and often conflicting roles. But there is little doubt that he remains one of the most formative and influential players in the history of American visual arts.'
	      ),
	      Glamor.createElement(
	        'p',
	        null,
	        'Critic, publicist, publisher, curator and photographer, he was a relentless advocate for photography\u2019s acceptance as a fine art form, championing future luminaries like Paul Strand and Ansel Adams in his publications, galleries and exhibitions\u2014only to later wage battle with them when they challenged his ideals. Stieglitz also spearheaded America\u2019s introduction to European modernist art by being the first to show Paul C\xE9zanne, Auguste Rodin, and others. He would later promote America\u2019s homegrown modernists, including his own photographic muse and eventual wife Georgia O\u2019Keefe, who once said of him that it was as though \u201Csomething hot, dark, and destructive was hitched to the highest, brightest star.\u201D'
	      ),
	      Glamor.createElement(
	        'p',
	        null,
	        'Born in Hoboken, New Jersey to German-Jewish immigrants shortly before the end of the Civil War, Stieglitz moved to Germany in 1881 in order to attend Berlin\u2019s prestigious Technische Hochschule. While ostensibly enrolled as an engineering student, he studied independently with the pioneering photo-chemist Hermann Vogel, under whose tutelage Stieglitz honed his own photographic skills to win first and second prizes in a contest sponsored by the English journal ',
	        Glamor.createElement(
	          'em',
	          null,
	          'Amateur Photographer'
	        ),
	        '. Stieglitz spent several years after graduation photographing the German countryside before returning to the U.S. in 1890. There he set out to elevate photography from mere documentary form to a proper fine art. With likeminded colleagues, he spearheaded the merger of New York\u2019s two premier photography organizations (The New York Camera Club and the Society of Amateur Photographers) into The Camera Club of New York, and expanded ',
	        Glamor.createElement(
	          'em',
	          null,
	          'Camera Notes'
	        ),
	        ', the Camera Club\u2019s former newsletter, into a photographic journal of which he assumed editorial leadership. As he would do with future publications, Stieglitz used ',
	        Glamor.createElement(
	          'em',
	          null,
	          'Camera Notes'
	        ),
	        ' as a platform from which to promote his favored photographers and photographic doctrine\u2014up until his 1902 ouster from The Camera Club by disgruntled fellow members. Undeterred, he promptly announced a new organization, The Photo-Secession, along with an exquisitely-produced quarterly journal called ',
	        Glamor.createElement(
	          'em',
	          null,
	          'Camera Work'
	        ),
	        ' that would, over the course of the next fourteen years, largely define American photography as an art form.'
	      ),
	      Glamor.createElement(
	        'p',
	        null,
	        'In 1905 Stieglitz opened his first curated art space, The Little Galleries of Photo-Secession. Shortened to 291, a reference to the gallery\u2019s Fifth Avenue address, the space initially showcased fellow Photo-Secessionists Edward Steichen, Alvin Langdon Coburn, Gertrude K\xE4sebier and Clarence H. White. All practiced Pictorialism, a Stieglitz-sanctioned photographic style that sought to counter the idea of photography as an exclusively mechanical medium, transforming it instead into an art form with the capability for nuance and abstraction as painting. Some of Stieglitz\u2019s own most known photographs from this period make clear references to modernist painting techniques. His 1911 print ',
	        Glamor.createElement(
	          'a',
	          { target: '_blank', href: 'https://www.metmuseum.org/toah/works-of-art/58.577.11/' },
	          Glamor.createElement(
	            'em',
	            null,
	            'The Terminal'
	          )
	        ),
	        ', for instance, uses steam to impressionistically soften the image of a horse-drawn trolley, while his 1913 print ',
	        Glamor.createElement(
	          'a',
	          { target: '_blank', href: 'https://www.metmuseum.org/toah/works-of-art/33.43.419/' },
	          Glamor.createElement(
	            'em',
	            null,
	            'The Steerage'
	          )
	        ),
	        ' reveals Cubist ideas of shape and space. Unsurprisingly, within a few years 291 expanded its exhibitional offerings to include painters, sculptors and printmakers, including the American debuts of Picasso, Matisse, C\xE9zanne and Toulouse-Lautrec. Nor is it surprising that when Albright Gallery in Buffalo, New York\u2014an esteemed institution dedicated to the more traditional fine arts\u2014offered to host a photography exhibition in 1910, Stieglitz saw it as the triumphant culmination of his decades-long battle to bring photography into the world of fine art\u2014and accordingly, included only photographers whose work, like his own, hewed to Pictorialism\u2019s more painterly ideals.'
	      ),
	      Glamor.createElement(
	        'p',
	        null,
	        'By 1917, however, perhaps in part due to the harsh realities of the First World War, Stieglitz\u2019s approach had shifted away from the misty prettiness of Pictorialism and he opened a new space, \u201CAn Intimate Gallery,\u201D to go with it. This change in direction was reflected in his exhibitive support for photographers like Paul Strand and Charles Scheer, newcomers whose work optimized the medium\u2019s natural strength in recording clean-lined and factual realities. At times, such support seemed conflicted: as Richard Wehlan writes in ',
	        Glamor.createElement(
	          'em',
	          null,
	          'Alfred Stieglitz'
	        ),
	        ', even as Stieglitz exhibited Strand\u2019s work he also complained openly to gallery-goers of the younger photographer\u2019s \u201Ctendency to imitate and his excessive emphasis on technical perfection.\u201D'
	      ),
	      Glamor.createElement(
	        'p',
	        null,
	        'Criticisms aside, the aesthetic directness embraced by Strand and others became a central tenet in Stieglitz\u2019s own work, perhaps most notably in the ',
	        Glamor.createElement(
	          'a',
	          { target: '_blank', href: 'https://www.metmuseum.org/toah/works-of-art/1997.61.19/' },
	          'serial portrait of O\u2019Keefe'
	        ),
	        ', begun in 1917. Stieglitz had met O\u2019Keefe in 1916, initially through her artwork, which he found so entrancing that he committed to exhibiting it before securing her permission. Upon meeting O\u2019Keefe in person his infatuation quickly spread to the artist, and the two began the affair that would eventually lead Stieglitz to divorce his then wife. His photographs of O\u2019Keefe spanned the next two decades and comprise hundreds of images that, taken together, form an impression of the artist that is visceral and kaleidoscopic. Stieglitz\u2019s 1925-1935 ',
	        Glamor.createElement(
	          'a',
	          { target: '_blank', href: 'https://www.metmuseum.org/toah/works-of-art/49.55.29/' },
	          '\u201CEquivalents\u201D series on clouds'
	        ),
	        '\u2014indirectly criticized by Berenice Abbott in her famed 1951 speech ',
	        Glamor.createElement(
	          'em',
	          null,
	          'It Has To Walk Alone'
	        ),
	        '\u2014takes a similarly abstract and cumulative approach that was intended to reflect his own inner (clearly complex) emotional state.'
	      ),
	      Glamor.createElement(
	        'p',
	        null,
	        'Stieglitz opened American Place, his final gallery, in 1929, where he continued to champion American modernists including O\u2019Keefe, Demuth and Arthur Dove for the next seventeen years. He also promoted a young Ansel Adams, who became the first photographer Stieglitz offered space to after a (perhaps inevitable) fallout with Paul Strand two decades earlier.'
	      ),
	      Glamor.createElement(
	        'p',
	        null,
	        'When the artist suffered a heart attack in 1938, he fell into a depression. His thunderous presence in the American art world receded, and he stopped taking photographs altogether. In 1946, Stieglitz suffered a fatal stroke. Like the man himself, Stieglitz\u2019s legacy, while both contentious and larger-than-life, is just as impossible to ignore.'
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-the-realist-alfred-stieglitz-js-5d2da75ae72c8d15950b.js